import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { PaginationBarComponent } from './pagination-bar/pagination-bar.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { NotificationComponent } from './drawer/components/notification/notification.component';
import { ColumnMapperComponent } from './column-mapper/column-mapper.component';
import { FileParserComponent } from './file-parser/file-parser.component';
import { TablePreviewerComponent } from './table-previewer/table-previewer.component';
import { AmButtonModule } from '@angularminds/am-button';
import { LoaderComponent } from './loader/loader.component';
import { WalletFilterComponent } from './wallet-filter/wallet-filter.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CurrentWalletComponent } from './current-wallet/current-wallet.component';

const COMPONENTS = [
  NotificationComponent,
  ColumnMapperComponent,
  FileParserComponent,
  TablePreviewerComponent,
  LoaderComponent,
  CurrentWalletComponent
];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PipesModule,
    AmButtonModule,
    NgSelectModule
  ],
  declarations: [...COMPONENTS, PaginationBarComponent, FileUploadComponent, WalletFilterComponent, CurrentWalletComponent],
  exports: [...COMPONENTS, PaginationBarComponent, FileUploadComponent, WalletFilterComponent],
  entryComponents: [...COMPONENTS],
  providers: [],
})
export class WidgetsComponentsModule { }
